import { requestPaymentTalk, useGetMembershipList } from '#api/member';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { ItemList } from '#pages/ReviewRequest/ItemList';
import { RequestButton } from '#pages/ReviewRequest/RequestButton';
import { useDashboard } from '#providers/Dashboard';
import { useToast } from '#providers/ToastProvider';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

interface PaymentRequestProps {}

const PaymentRequestPage = ({}: PaymentRequestProps) => {
  const [selectedMembership, setSelectedMembership] = useState<string[]>([]);

  const { customerDetail } = useDashboard();

  const { data } = useGetMembershipList(
    customerDetail.person ? customerDetail.person.id : ''
  );

  const { showToast } = useToast();

  const queryClient = useQueryClient();

  const onClick = async () => {
    try {
      await Promise.all(
        selectedMembership.map(membershipId =>
          requestPaymentTalk(customerDetail.person.id, membershipId)
        )
      );

      queryClient.invalidateQueries([
        queryKeyFactory.GET_MEMBERSHIP_LIST(customerDetail?.person.id),
        customerDetail?.person.id
      ]);

      showToast({
        type: 'success',
        message: '결제 요청이 완료되었습니다.'
      });
    } catch (error) {
      showToast({
        type: 'fail',
        message: '결제 요청에 실패했습니다.'
      });
    }
  };

  return (
    <PrevHeaderBarWithTitleTemplate title="결제 요청" defaultBackground>
      <div className="px-20 py-28">
        <div className="text-[#bcb8c3] text-lg font-medium font-['Pretendard Variable'] leading-snug">
          회원님께 카카오톡 알림톡으로 <br />
          결제 요청 메세지를 보내드려요!
        </div>
        <div className="h-28 w-full"></div>
        <ItemList
          data={data?.data.memberships}
          selectedMembership={selectedMembership}
          setSelectedMembership={setSelectedMembership}
        />
      </div>
      <div className="h-100 w-full"></div>
      <RequestButton
        onClick={onClick}
        disabled={selectedMembership.length === 0}
      />
    </PrevHeaderBarWithTitleTemplate>
  );
};

export default PaymentRequestPage;
